"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const CommonBaseError_1 = require("../Common/CommonBaseError");
exports.FudaoSessionFacadeErrorName = "FudaoSessionFacadeError";
class FudaoSessionFacadeError extends CommonBaseError_1.CommonBaseError {
}
exports.FudaoSessionFacadeError = FudaoSessionFacadeError;
//# sourceMappingURL=IFudaoSessionFacade.js.map